import React, { useState, useEffect } from 'react';

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if user is already authenticated (stored in localStorage)
  useEffect(() => {
    const authStatus = localStorage.getItem('modiq-authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Support multiple passwords separated by commas
    const passwordsString = process.env.REACT_APP_ACCESS_PASSWORD || 'modiq2024';
    const validPasswords = passwordsString.split(',').map(p => p.trim());
    
    if (validPasswords.includes(password)) {
      setIsAuthenticated(true);
      localStorage.setItem('modiq-authenticated', 'true');
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('modiq-authenticated');
  };

  if (isAuthenticated) {
    return (
      <div>
        {/* Logout button moved to settings panel */}
        {React.cloneElement(children, { onLogout: handleLogout })}
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8fafc',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src="/images/modiq-logo-sm.png" alt="ModIQ Logo" style={{ height: '60px', marginBottom: '1rem' }} />
          <h2 style={{ margin: '0 0 0.5rem 0', color: '#1f2937' }}>Access Required</h2>
          <p style={{ margin: 0, color: '#6b7280', fontSize: '0.875rem' }}>
            Please enter the password to access ModIQ
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontSize: '0.875rem',
              fontWeight: '500',
              color: '#374151'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
              placeholder="Enter password"
              required
            />
          </div>

          {error && (
            <div style={{
              padding: '0.75rem',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '6px',
              marginBottom: '1rem'
            }}>
              <p style={{ margin: 0, color: '#dc2626', fontSize: '0.875rem' }}>
                {error}
              </p>
            </div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer'
            }}
          >
            Access ModIQ
          </button>
        </form>

        <div style={{
          marginTop: '1.5rem',
          padding: '1rem',
          backgroundColor: '#f9fafb',
          borderRadius: '6px'
        }}>
          <p style={{
            margin: 0,
            fontSize: '0.75rem',
            color: '#6b7280',
            textAlign: 'center'
          }}>
            This is a password-protected environment
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate; 